
import { useEffect, useState } from "react"
import styled from "styled-components"
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"

const Container = styled.div`
    width: 500px;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    textarea{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        resize: vertical;
        min-height: 40px;
        max-height: 140px;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    textarea:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        top: 14px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    @media (max-width: 1200px){
        width: 300px !important;
    }
`

const BosaltmaAdresInput = ({data, name, isRequired, labelText = "Adres"}) => {

    const [text, setText] = useState(data.adres)
    const {showErrors, showRequiredPlaces} = useSelector(state => state.addLoad)
    const [isError, setIsError] = useState(false)
    const dispatch = useDispatch()

    const handleChange = (e) => {
        setText(e.target.value)

        const updatedItem = {
            id: data.id,
            adres: e.target.value
        }
        dispatch(updateRouteItem(updatedItem))
    }

    useEffect(()=> {
        setText(data.adres)
    },[data.adres])

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && data.adres === "" && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.adres, showRequiredPlaces, showErrors])

    
  return (
    <Container onClick={(e)=>e.stopPropagation()} value={text} radius={"5px"} isError={isError}>
        <textarea  id={"text"} onChange={handleChange} value={text} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default BosaltmaAdresInput